/**
 * Downloads a file from a URL as a blob and triggers the browser download.
 * Falls back to a direct navigation when the blob fetch fails (e.g. CORS).
 */
export const downloadReportFile = async (url: string, fileName: string): Promise<void> => {
  const safeName = fileName.replace(/[^a-zA-Z0-9._\- ]/g, "_");
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error("Download failed");
    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", `${safeName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  } catch {
    window.location.href = url;
  }
};
